import React from 'react';
import { Navigate } from 'react-router';

import { Loadable } from '../../../components/navigation/Loadable';
import { MedicinalCannabisFormRoute, NicotineFormRoute } from './formRoutes/index.ts';

/**
 * @satisfies {ExtendedRouteObject[]}
 */
export const baseFormsRoutes = [
  {
    name: 'Medicinal Cannabis Form',
    path: 'alternative-therapy-form',
    type: 'item',
    element: <MedicinalCannabisFormRoute />,
  },
  {
    // Redirect from old path
    name: 'Medicinal Cannabis Form Redirect',
    path: 'medicinal-cannabis-form',
    type: 'item',
    element: <Navigate to="/alternative-therapy-form" replace />,
  },
  {
    name: 'Hair Loss Form',
    path: 'hair-loss-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/hair-loss-form'))),
  },
  {
    name: 'Weight Loss Form',
    path: 'weight-loss-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/weight-loss-form'))),
  },
  // Disable the sleep form route as a band-aid solution to prevent access.
  // Remove this code comment once we have fully deprecated the Sleep consult.
  // See https://doctorsondemand.atlassian.net/browse/CD-728
  // {
  //   name: 'Sleep Form',
  //   path: 'sleep-form',
  //   type: 'item',
  //   element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/sleep-form'))),
  // },
  {
    name: 'Cold Sores Form',
    path: 'cold-sores-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/cold-sores-form'))),
  },
  {
    name: 'Herpes Form',
    path: 'herpes-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/herpes-form'))),
  },
  {
    name: 'Acne Form',
    path: 'acne-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/acne-form'))),
  },
  {
    name: 'Ageing Form',
    path: 'ageing-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/ageing-form'))),
  },
  {
    name: 'Contraceptive Pill Form',
    path: 'contraceptive-pill-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/contraceptive-pill-form'))),
  },
  {
    name: 'Allergies Form',
    path: 'allergies-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/allergies-form'))),
  },
  {
    name: 'Erectile Dysfunction Form',
    path: 'erectile-dysfunction-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/erectile-dysfunction-form'))),
  },
  {
    name: 'Skincare Form',
    path: 'skincare-form',
    type: 'item',
    element: Loadable(React.lazy(() => import('../../../components/form/standard-forms/skincare-form'))),
  },
  {
    name: 'Nicotine Form',
    path: 'quit-smoking-form',
    type: 'item',
    element: <NicotineFormRoute />,
  },

  // {
  //   // Redirect from old path
  //   name: 'Nicotine Form Redirect',
  //   path: 'nicotine-form',
  //   type: 'item',
  //   element: <Navigate to="/quit-smoking-form" replace />,
  // },

  // Note: if it is ready to release to public, uncomment above code and remove the codeblock below.
  ...(import.meta.env.VITE_IS_NVP_ENABLED === 'true'
    ? [
        /** @type {ExtendedRouteObject} */ ({
          // Redirect from old path
          name: 'Nicotine Form Redirect',
          path: 'nicotine-form',
          type: 'item',
          element: <Navigate to="/quit-smoking-form" replace />,
        }),
      ]
    : []),
];
